import React, { useEffect, useMemo, useState } from "react"
import AgGridTable from "../utilities/AgGridTable"
import ListPageHeader from "../utilities/ListPageHeader"
import { useRef } from "react"
import { AppBar, Badge, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Icon, IconButton, List, ListItem, ListItemText, MenuItem, Select as MuiSelect, Popover, Stack, Switch, TextField, Toolbar, Tooltip, Typography } from "@mui/material"
import Select from "react-select"
import customStyles from "app/shared-components/SelectCustomStyle"
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig"
import OAuthService from "src/app/auth/services/oAuthService"
import FuseSvgIcon from "@fuse/core/FuseSvgIcon"
import LetterOfCreditForm from "./LetterOfCreditForm"
import { useCallback } from "react"
import CreateDocument from "./CreateDocument"
import LCTopUp from "./LCTopUp"
import moment from "moment"
import LCUtilized from "./LCUtilized"
import LCStatusList from "./LCPendingList"
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state"
import jwtDecode from "jwt-decode";
import DialogBox from "../utilities/DialogBox"

const LetterOfCredit = () => {

    const gridRef = useRef()
    const gridCashflowRef = useRef()
    const childRef = useRef()
    const [rowData, setRowData] = useState([]);
    const [expandRowData, setExpandRowData] = useState("collapse");
    const [selectedRows, setSelectedRows] = useState([]);
    const [notificationData, setNotificationData] = useState([]);
    const [containerNo, setContainerNo] = useState();
    const [bankRef, setBankRef] = useState()
    const [formOpen, setFormOpen] = useState(false);
    const [selectedSize, setSelectedSize] = useState(10);
    const [successMsg, setSuccessMsg] = useState();
    const [snackState, setSnackState] = useState(false);
    const [ammendSelected, setAmmendSelected] = useState();
    const [creationformOpen, setCreationFormOpen] = useState(false)
    const [openLCTopup, setOpenLCTopup] = useState(false)
    const [viewData, setViewData] = useState(false)
    const [ammendId, setAmmendId] = useState()
    const [selectedLcId, setSelectedLcId] = useState()
    const [lCTopupId, setLCTopupId] = useState()
    const [openUtilized, setOpenUtilized] = useState()
    const [openPending, setOpenPending] = useState()
    const [openAccepted, setOpenAccepted] = useState(false)
    const [addSelected, setAddSelected] = useState()
    const [openReceived, setOpenReceived] = useState(false)
    const [showLCCashFlow, setShowLCCashFlow] = useState(false)
    const [saveDisabled, setSaveDisabled] = useState(true);
    const [BOEXDisabled, setBOEXDisabled] = useState(true);
    const [error, setError] = useState()
    const [active, setActive] = useState(false);
    const [open, setOpen] = useState(false);
    const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));
    const AddlcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.letterOfCredits}`;

    const renderCurrency = (props) => {
        const options = {
            style: "decimal", // Other options: 'currency', 'percent', etc.
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          };
          return (
            <span style={{ display: "flex" }}>
              <p>
                {props?.value 
                  ? Number(props?.value).toLocaleString("en-US", options)
                  : "0.00"}
              </p>
            </span>
          );
    };

    const checkReconciled = (props) => {
        return <Switch size={'small'} checked={props.value} />
    }

    const handleTopUpOpen = (params) => {
        const options = {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
        return params.value ? <Button size="small" className="p-0" onClick={() => { setOpenLCTopup(true); setLCTopupId(params.data.id) }}>{Number(params?.value).toLocaleString("en-US", options)}</Button> : "0.00";

    }

    const handleUtilizedOpen = (params) => {
        const options = {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
        return params.value ? <Button size="small" className="p-0" onClick={() => { setOpenUtilized(true); setLCTopupId(params.data.id) }}>{Number(params?.value).toLocaleString("en-US", options)}</Button> : "0.00"
    }

    const handledOpenPending = (params) => {
        const options = {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
        return params.value ? <Button size="small" className="p-0" onClick={() => { setOpenPending(true); setLCTopupId(params.data.id) }}>{Number(params?.value).toLocaleString("en-US", options)}</Button> : "0.00"
    }

    const handledOpenAccepted = (params) => {
        const options = {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
        return params.value ? <Button size="small" className="p-0" onClick={() => { setOpenAccepted(true); setLCTopupId(params.data.id) }}>{Number(params?.value).toLocaleString("en-US", options)}</Button> : "0.00"
    }


    const handledOpenReceived = (params) => {
        const options = {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
        return params.value ? <Button size="small" className="p-0" onClick={() => { setOpenReceived(true); setLCTopupId(params.data.id) }}>{Number(params?.value).toLocaleString("en-US", options)}</Button> : "0.00"
    }

    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }

    const handleActions = (params) => {
        return params.data && <>
            <IconButton size="small" className="p-0" onClick={(e) => handleLCView(params?.data?.documentCreditNo)}><Icon >visibility</Icon></IconButton>
        </>
    }

    const currentYear = (new Date()).getFullYear();
    const [columnCashFlowDefs, setColumnCashFlowDefs] = useState([
        {
            field: 'code',
            cellRenderer: 'agGroupCellRenderer'
        },
        {
            field: 'customerName',
        },
        {
            field: 'lcNumber', headerName: 'LC Number',
        },
        { field: 'tendor', headerName: 'Tenor', },
        { field: 'blDate', cellRenderer: handleDateFormat },
        { field: 'maturity', cellRenderer: handleDateFormat },
        { field: 'discountingDate', cellRenderer: handleDateFormat },
        { field: 'discountingRate',cellRenderer:renderCurrency },
        { field: 'discountingCost', cellRenderer:renderCurrency},
        { field: 'pending', headerName: 'Pending' ,cellRenderer:renderCurrency},
        { field: 'accepted', headerName: 'Accepted' ,cellRenderer:renderCurrency},
        { field: `1_${currentYear}`, headerName: `Jan-${currentYear}` },
        { field: `2_${currentYear}`, headerName: `Feb-${currentYear}` },
        { field: `3_${currentYear}`, headerName: `Mar-${currentYear}` },
        { field: `4_${currentYear}`, headerName: `Apr-${currentYear}` },
        { field: `5_${currentYear}`, headerName: `May-${currentYear}` },
        { field: `6_${currentYear}`, headerName: `Jun-${currentYear}` },
        { field: `7_${currentYear}`, headerName: `Jul-${currentYear}` },
        { field: `8_${currentYear}`, headerName: `Aug-${currentYear}` },
        { field: `9_${currentYear}`, headerName: `Sep-${currentYear}` },
        { field: `10_${currentYear}`, headerName: `Oct-${currentYear}` },
        { field: `11_${currentYear}`, headerName: `Nov-${currentYear}` },
        { field: `12_${currentYear}`, headerName: `Dec-${currentYear}` },
    ])
    const [columnDefs, setColumnDefs] = useState([
        {
            field: 'company', headerName: 'Code',
            cellRenderer: 'agGroupCellRenderer'
        },
        {
            field: 'companyName', headerName: 'Customer Name',
        },
        { field: 'orderType', headerName: 'Order Type', },
        { field: 'dateOfIssue', headerName: 'Date Of Issue', cellRenderer: handleDateFormat },
        { field: 'expiryDate', headerName: 'Expiry', cellRenderer: handleDateFormat },
        { field: 'lastDateOfShipment', headerName: 'Last Date Of Shipment', cellRenderer: handleDateFormat },
        {
            field: 'documentCreditNo', headerName: 'LC Number',
        },
        { field: 'totalDCAmount', headerName: 'Principal LC Value', cellRenderer: renderCurrency },
        { field: 'topUpTillDate', headerName: 'Top Up Till Date', cellRenderer: handleTopUpOpen, },
        { field: 'totalLcValue', headerName: 'Total LC Value', cellRenderer: renderCurrency },
        { field: 'balance', headerName: 'Balance', cellRenderer: renderCurrency },
        { field: 'utilized', headerName: 'Utilized', cellRenderer: handleUtilizedOpen },
        { field: 'pending', headerName: 'Pending', cellRenderer: handledOpenPending },
        { field: 'accepted', headerName: 'Accepted', cellRenderer: handledOpenAccepted },
        { field: 'received', headerName: 'Received', cellRenderer: handledOpenReceived },
        { field: 'planValue', headerName: 'Plan Value', },
        { field: 'piNumber', headerName: 'PI NUMBER', },
        { field: 'piDate', headerName: 'PI DATE', cellRenderer: handleDateFormat },
        { field: 'piValue', headerName: 'PI VALUE', },
        { field: 'saleMonth', headerName: 'SALE MONTH', },
        { field: 'runningBalance', headerName: 'Running Balance', minWidth: 120 },
        {
            field: 'deficitMonth', headerName: 'Deficit Month',
        },

        { field: 'reconciled', headerName: 'Reconciled', cellRenderer: checkReconciled, editable: false },

        {
            field: 'active', headerName: 'Active', cellRenderer: IconComponent, editable: true
        },
        {
            field: 'view', headerName: 'View',
            cellRenderer: handleActions
        },
    ]);


    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                columnDefs: [
                    { field: 'customerName' },
                    { field: 'dateOfIssue', cellRenderer: handleDateFormat },
                    { field: 'lcNumber' },
                    { field: 'principalLcValue',cellRenderer: renderCurrency  },
                    { field: 'topUpTillDate',cellRenderer: renderCurrency  },
                    { field: 'totalLcValue',cellRenderer: renderCurrency  },
                    { field: 'balance',cellRenderer: renderCurrency  },
                    { field: 'utilized',cellRenderer: renderCurrency  },
                    { field: 'pending',cellRenderer: renderCurrency  },
                    { field: 'accepted',cellRenderer: renderCurrency  },
                    { field: 'received',cellRenderer: renderCurrency  },
                ],
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: function (params) {
                params.successCallback(params.data.transactionList);
            },
        };
    }, []);
    const detailCashFlowCellRendererParams = useMemo(() => {

        return {
            detailGridOptions: {
                columnDefs: [
                    { field: 'customerName' },
                    { field: 'lcNumber' },
                    { field: 'tendor' },
                    { field: 'blDate', cellRenderer: handleDateFormat },
                    { field: 'docDate', headerName: 'Maturity', cellRenderer: handleDateFormat },
                    { field: 'discountingDate', cellRenderer: handleDateFormat },
                    { field: 'discountingRate',cellRenderer:renderCurrency },
                    { field: 'discountingCost',cellRenderer:renderCurrency },
                    { field: 'pending',cellRenderer:renderCurrency },
                    { field: 'accepted', cellRenderer:renderCurrency},
                    { field: `1_${currentYear}`, headerName: `Jan-${currentYear}` },
                    { field: `2_${currentYear}`, headerName: `Feb-${currentYear}` },
                    { field: `3_${currentYear}`, headerName: `Mar-${currentYear}` },
                    { field: `4_${currentYear}`, headerName: `Apr-${currentYear}` },
                    { field: `5_${currentYear}`, headerName: `May-${currentYear}` },
                    { field: `6_${currentYear}`, headerName: `Jun-${currentYear}` },
                    { field: `7_${currentYear}`, headerName: `Jul-${currentYear}` },
                    { field: `8_${currentYear}`, headerName: `Aug-${currentYear}` },
                    { field: `9_${currentYear}`, headerName: `Sep-${currentYear}` },
                    { field: `10_${currentYear}`, headerName: `Oct-${currentYear}` },
                    { field: `11_${currentYear}`, headerName: `Nov-${currentYear}` },
                    { field: `12_${currentYear}`, headerName: `Dec-${currentYear}` },
                ],
                defaultColDef: {
                    flex: 1,
                },
            },
            getDetailRowData: function (params) {
                params.successCallback(params.data.documents);
            },
        };
    }, []);

    function IconComponent(props) {
        let bool = props?.data?.isActive
        return <Switch size={"small"} checked={bool} onClick={() => { handleSwitchClick(bool) }} />
    }

    const handleSwitchClick = (bool) => {
        setActive(bool);
        setOpen(true);
    }

    const [listOption, setListOption] = useState([
        { label: 'All', value: 'All' },
        { label: 'Active', value: 'Active' },
        { label: 'In Active', value: 'Inactive' },
    ]);
    const [listType, setListType] = useState();

    const lcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.letterOfCredit}`;
    const lcDocUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.lcDocument}`;

    const loadLCData = async () => {
        if (token?.scope?.includes('ROLE_FINANCE') || token?.scope?.includes('ROLE_FINMGR') || token?.scope?.includes('ROLE_MD') || token?.scope?.includes('ROLE_SOPDIR')) {
            try {
                let obj = {}
                if (listType === 'All') {
                    delete obj.status;
                } else {
                    obj = { ...obj, status: listType, containerNo: containerNo, bankRefNo: bankRef };
                }
                const allIds = []
                if (showLCCashFlow) {
                    const all = await OAuthService.getList(lcDocUrl + `/lcCashFlow`);
                    if (all.data) {
                        const listData = all.data.map((data) => {
                            if (data.documents.length > 0) {
                                data.documents.map((doc) => {
                                    doc[`${doc.lcTracker.month}_${doc.lcTracker.year}`] = doc.lcTracker.amount;
                                    return doc;
                                })
                            }
                            return data;
                        })
                        setRowData(all.data)
                        onFirstDataRendered()
                    } else {
                        setRowData([])
                    }
                } else {
                    const all = await OAuthService.addData(lcUrl + `/getAll`, obj);
                    all.data && all.data.map((data) => {
                        if (data.id) {
                            allIds.push(data.id)
                        }
                        return data;
                    })
                    if (allIds.length > 0) {
                        const list = await OAuthService.addData(lcUrl + `/transactions`, allIds);

                        let expandList = list?.data.map((data) => {
                            if (data.transactionList && data.transactionList.length > 0) {

                                return { ...data, ...data?.transactionList[0].letterOfCredit };
                            }
                            return data;
                        })
                        setRowData(expandList)
                        onFirstDataRendered()
                    } else {
                        setRowData([])
                    }
                }

            } catch (error) {

            }

        } else {
            setError("You don't have privileges to view Letter Of Credit")
        }
    }

    const refreshCache = useCallback(() => {
        gridRef.current.api.refreshCells();
    }, []);

    const handleSubmitActive = () => {
        // let model = {active}
        // let activeId = selectedRows[0].id;
        // await OAuthService.updateData(AddlcUrl, activeId, model);
        // setSuccessMsg('LC Updated successfully.')
        selectedRows.map(async (row) => {
            try {
                row.isActive = !row.isActive
                const data = await OAuthService.updateData(AddlcUrl, row.id, { isActive: row.isActive });

                if (data) {
                    loadLCData();
                }
            } catch (error) {
            }

        })
        refreshCache();
        setOpen(false)

    }

    const onFirstDataRendered = () => {
        const allColumnIds = [];
        gridRef?.current?.columnApi?.getColumns()?.forEach((column) => {
            allColumnIds.push(column.getId());
        });
        gridRef?.current?.columnApi?.autoSizeColumns(allColumnIds);
        const allColumns = [];
        gridCashflowRef?.current?.columnApi?.getColumns()?.forEach((column) => {
            allColumns.push(column.getId());
        });
        gridCashflowRef?.current?.columnApi?.autoSizeColumns(allColumns);
    };

    const handleExpiryNotification = async () => {
        const list = await OAuthService.getList(lcUrl + '/getLcExpiry');
        if (list?.data) {
            setNotificationData(list?.data)
        }
    }

    useEffect(() => {
        handleSuccessMsg();
        handleExpiryNotification();
    }, []);

    useEffect(() => {
        const gridRefToUse = showLCCashFlow ? gridCashflowRef : gridRef;
        if (rowData.length > 0) {
            onFirstDataRendered()
        }
        setTimeout(() => {
            onFirstDataRendered(gridRefToUse);
        });
    }, [rowData])

    const handleSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg);
            setSnackState(true);
            loadLCData();
            setOpenUtilized(false)
        } else {
            setSnackState(false)
        }
    }

    const handlecreateSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg)
            setSnackState(true)
        } else {
            setSnackState(false)
        }
    }

    const onGridReady = () => {
        loadLCData()
    }

    const handleExpandedCollapse = () => {
        if (expandRowData === 'expand') {
            setTimeout(function () {
                if (gridRef.current) {
                    gridRef.current.api.forEachNode(function (node) {
                        node.setExpanded(true);
                    });
                } else {
                    gridCashflowRef.current.api.forEachNode(function (node) {
                        node.setExpanded(true);
                    });
                }
            }, 0);
        } else {
            setTimeout(function () {
                if (gridRef.current) {
                    gridRef.current.api.forEachNode(function (node) {
                        node.setExpanded(false);
                    });
                } else {
                    gridCashflowRef.current.api.forEachNode(function (node) {
                        node.setExpanded(false);
                    });
                }
            }, 0);
        }
    }

    useEffect(() => {
        handleExpandedCollapse()
    }, [expandRowData])

    useEffect(() => {
        loadLCData()
    }, [listType, showLCCashFlow, containerNo, bankRef])

    const handleListTypeChange = (data) => {
        setListType(data.value)
    }

    const onSelectionChanged = (params) => {
        let select = params.api.getSelectedRows()
        setSelectedRows(select);
    }

    const hanldeContainerChange = (event) => {
        setContainerNo(event.target.value)
    }

    const handleChangeBankRef = (event) => {
        setBankRef(event.target.value)
    }

    const handleAddButton = () => {
        setAddSelected('Add')
        setAmmendSelected('')
        setSelectedLcId('')
        setFormOpen(true)
    }
    const handleAmmend = () => {
        setFormOpen(true);
        setAmmendSelected('Ammend')
        setAddSelected('')
    }

    const handleLCView = async (id) => {
        setSelectedLcId(id)
        setFormOpen(true)
        setViewData(true);
        setAmmendSelected('')
        setAddSelected('')
    }

    const handleSave = () => {
        let checkClose = false;
        if (openLCTopup) {
            closeOpenLCTopup();
            checkClose = true
        }
        const childelement = childRef.current;
        const submitData = childelement.handleSubmit();
        submitData.then((val) => {
            if (val) {
                handleFormClose();
                checkClose && setOpenLCTopup(true)
                loadLCData();
            }
        })
    }

    const handleFormClose = () => {
        setFormOpen(false);
        setCreationFormOpen(false)
        setAmmendId('');
        setAmmendSelected('')
        setSelectedLcId('')
        setViewData(false);
        setAddSelected('')
        setOpen(false)
    }

    const onPageSizeChanged = useCallback((e) => {
        setSelectedSize(e.target.value);
        var value = e.target.value;
        gridRef.current.api.paginationSetPageSize(value);
    }, []);

    const handleCreateDocument = () => {
        setCreationFormOpen(true)
    }

    const handleSaveDocument = () => {
        const childelement = childRef.current;
        const submitData = childelement.handleSubmit();
        submitData.then((val) => {
            if (val) {
                handleFormClose()
                loadLCData();
            }
        })
    }

    const closeOpenLCTopup = () => {
        setOpenLCTopup(false);
        setOpenUtilized(false);
        setOpenPending(false);
    }

    const checkSaveDisabled = (value) => {
        setSaveDisabled(value)
    }

    useEffect(() => {
        checkSaveDisabled()
    }, [])

    const checkBOEXDisabled = (value) => {
        setBOEXDisabled(value)
    }

    useEffect(() => {
        checkBOEXDisabled()
    }, [])

    const handleDownloadBOEX = () => {
        const childelement = childRef.current;
        childelement.handleDownloadBOEX();
    }

    const handleAmmendView = (id) => {
        setFormOpen(true);
        setAmmendSelected('Ammend')
        setAmmendId(id);
        setAddSelected('')
        setViewData(true)
    }
    const handleAmmendEdit = (id) => {
        setFormOpen(true);
        setAmmendSelected('Ammend')
        setAmmendId(id);
        setAddSelected('')
        setViewData(false)
    }

    const handleEdit = () => {
        setAmmendSelected('')
        setSelectedLcId('')
        setAmmendId('');
        setViewData(false)
        setFormOpen(true);
        setAddSelected('')
    }

    const closeOpenLCStatus = () => {
        setOpenAccepted(false);
        setOpenReceived(false);
        setOpenPending(false);
    }

    const lcInputField = () => {
        return <>
            {(token?.scope?.includes('ROLE_FINANCE') || token?.scope?.includes('ROLE_FINMGR') || token?.scope?.includes('ROLE_MD') || token?.scope?.includes('ROLE_SOPDIR')) &&
                <>
                    <PopupState variant="popover" popupId="demo-popup-popover">
                        {(popupState) => (
                            <div>
                                <IconButton className="pl-10 pr-10" {...bindTrigger(popupState)}>
                                    <Badge color="primary" badgeContent={notificationData?.length} showZero>
                                        <FuseSvgIcon>material-outline:notifications</FuseSvgIcon>
                                    </Badge>
                                </IconButton>
                                <Popover
                                    {...bindPopover(popupState)}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    sx={{
                                        maxHeight: '300px'
                                    }}
                                >
                                    <Typography sx={{ p: 2 }}>
                                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                            {notificationData.length > 0 && notificationData.map((data) => {
                                                return (<>
                                                    <ListItem alignItems="flex-start">
                                                        <ListItemText
                                                            primary={data.lcNumber}
                                                            secondary={
                                                                <React.Fragment>
                                                                    <Typography
                                                                        component="div"
                                                                    >
                                                                        Expiry in {data.expiry} Days
                                                                    </Typography>
                                                                    <Typography
                                                                        component="div"
                                                                    >
                                                                        Last Day Of Shipment in {data.lastDayOfShipment} Days
                                                                    </Typography>
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <Divider variant="inset" component="li" className="ml-0" />
                                                </>)
                                            })}
                                        </List>
                                    </Typography>
                                </Popover>
                            </div>
                        )}
                    </PopupState>
                    {!showLCCashFlow && <Tooltip title={"Add Letter Of Credit"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: "4px" }}
                            onClick={handleAddButton}
                        >
                            <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                        </Button>

                    </Tooltip>}
                    {!showLCCashFlow && <Tooltip title={"AMMEND"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: "4px" }}
                            onClick={handleAmmend}
                        >
                            <FuseSvgIcon>material-solid:edit_note</FuseSvgIcon>
                        </Button>
                    </Tooltip>}
                    {!showLCCashFlow && <Tooltip title={"LC -Document Create"}>
                        <Button
                            variant="contained"
                            color="warning"
                            style={{ marginLeft: "4px" }}
                            onClick={handleCreateDocument}
                        >
                            <FuseSvgIcon>material-solid:post_add</FuseSvgIcon>
                        </Button>
                    </Tooltip>}
                    {(selectedRows && selectedRows.length > 0) &&
                        <>
                            <Tooltip title={"Edit LC"}>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    style={{ marginLeft: "4px" }}
                                    onClick={handleEdit}
                                >
                                    <FuseSvgIcon>material-solid:edit</FuseSvgIcon>
                                </Button>
                            </Tooltip>


                        </>
                    }
                    {(expandRowData === "collapse") ?
                        < Tooltip title={"Expand Letter Of credit"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" }}
                                onClick={() => setExpandRowData('expand')}
                            >
                                <FuseSvgIcon>material-outline:unfold_more</FuseSvgIcon>
                            </Button>
                        </Tooltip>
                        :

                        <Tooltip title={"Collapse Letter Of credit"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" }}
                                onClick={() => { setExpandRowData('collapse'); setSelectedRows([]) }}
                            >
                                <FuseSvgIcon>material-outline:unfold_less</FuseSvgIcon>
                            </Button>
                        </Tooltip>
                    }
                    {showLCCashFlow ?
                        <Tooltip title={"LC Tracker"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" }}
                                onClick={() => { setRowData([]); setShowLCCashFlow(false) }}
                            >
                                <FuseSvgIcon>material-outline:list_alt</FuseSvgIcon>
                            </Button>
                        </Tooltip>
                        : <Tooltip title={"LC Cash Flow"}>
                            <Button
                                variant="contained"
                                color="warning"
                                style={{ marginLeft: "4px" }}
                                onClick={() => { setRowData([]); setShowLCCashFlow(true); }}
                            >
                                <FuseSvgIcon>material-outline:account_tree</FuseSvgIcon>
                            </Button>
                        </Tooltip>}
                </>
            }
        </>
    }

    return <>
        <ListPageHeader
            componentName={'Letter Of Credit'}
            pageName={showLCCashFlow ? 'LC Cash Flow' : 'Letter Of Credit'}
            gridRef={gridRef}
            headerInputFields={lcInputField()}
            showPaginationDropdown={false}
            successMsg={successMsg}
            snackState={snackState}
            error={error}
        />
        {(token?.scope?.includes('ROLE_FINANCE') || token?.scope?.includes('ROLE_FINMGR') || token?.scope?.includes('ROLE_MD') || token?.scope?.includes('ROLE_SOPDIR')) &&
            <Stack direction={'row'} className="mb-10 md:px-16 self-end ">
                <div className="flex flex-row">
                    <div className="flex flex-row justify-between items-baseline">
                        {/* <FormControl className={"flex"} size="small">
                            <label className="pt-12 min-w-fit">Page Size</label>
                            <MuiSelect onChange={onPageSizeChanged} className='ml-5 h-fit min-w-[150px]' value={selectedSize} id="page-size"
                                // native={true}
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}
                            >
                                <MenuItem value="10">10</MenuItem>
                                <MenuItem value="20">20</MenuItem>
                                <MenuItem value="50">50</MenuItem>
                                <MenuItem value="100">100</MenuItem>
                            </MuiSelect>
                        </FormControl> */}
                        {!showLCCashFlow && <Stack className="ml-10">
                            <label className="min-w-fit">Container No. </label>
                            <div className="grid">
                                <TextField
                                    name="containerNo"
                                    value={containerNo}
                                    onChange={hanldeContainerChange}
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}
                                />
                            </div>
                        </Stack>}
                        {!showLCCashFlow && <Stack className="ml-10">
                            <label className="min-w-fit">Bank Reference No. </label>
                            <div className="grid">
                                <TextField
                                    name="bank_ref"
                                    value={bankRef}
                                    onChange={handleChangeBankRef}
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}
                                />
                            </div>
                        </Stack>}
                        {!showLCCashFlow && <Stack className="ml-10">
                            <label className="min-w-fit">List </label>
                            <div className="grid">
                                <Select
                                    options={listOption}
                                    value={(listType && listOption.length > 0) && listOption.filter((data) => data.value === listType)}
                                    onChange={handleListTypeChange}
                                    styles={customStyles('', '', '0px')}
                                />
                            </div>
                        </Stack>}
                    </div>
                </div>
            </Stack>
        }
        {showLCCashFlow ?
            <AgGridTable
                gridRef={gridCashflowRef}
                rowData={rowData}
                columnDefs={columnCashFlowDefs}
                suppressRowTransform={true}
                onSelectionChanged={onSelectionChanged}
                editable={false}
                masterDetail={true}
                detailCellRendererParams={detailCashFlowCellRendererParams}
                detailRowHeight={'auto'}
                onFirstDataRendered={onFirstDataRendered}
            />
            : <AgGridTable
                gridRef={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                suppressRowTransform={true}
                onSelectionChanged={onSelectionChanged}
                editable={false}
                masterDetail={true}
                detailCellRendererParams={detailCellRendererParams}
                detailRowHeight={'auto'}
                onFirstDataRendered={onFirstDataRendered}
            />}

        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            onClose={handleFormClose}
            open={formOpen}
        >
            {/* <DialogTitle>
                <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                    <span>{ammendSelected ? viewData ? 'LC Ammendment View' : 'LC Ammendment' : viewData ? 'View Letter Of Credit' : 'Add Letter Of Credit'}</span>
                    <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                        <Button onClick={handleFormClose}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
                    </div>
                </div>
            </DialogTitle> */}

            <AppBar position="static">
                <Toolbar className="flex w-full justify-between">
                    <Typography variant="subtitle1" color="inherit">
                        {ammendSelected ? viewData ? 'LC Ammendment View' : 'LC Ammendment' : viewData ? 'View Letter Of Credit' : addSelected ? 'Add Letter Of Credit' : 'Edit Letter Of Credit'}
                    </Typography>
                    <Button onClick={handleFormClose}>
                        <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                    </Button>
                </Toolbar>
            </AppBar>

            <DialogContent dividers>
                {<LetterOfCreditForm
                    addSelected={addSelected}
                    type={ammendSelected}
                    selectedRow={selectedRows}
                    viewData={viewData}
                    ammendId={ammendId}
                    lcId={selectedLcId}
                    ref={childRef}
                    successMsg={handleSuccessMsg}
                    checkSaveDisabled={checkSaveDisabled} />}
            </DialogContent>
            <DialogActions>
                {!viewData && <Button
                    variant="contained"
                    color="warning"
                    onClick={handleSave}
                    disabled={saveDisabled}
                >
                    <FuseSvgIcon>material-solid:save</FuseSvgIcon>
                </Button>}
            </DialogActions>
        </Dialog>

        <Dialog
            fullWidth={true}
            maxWidth={'md'}
            onClose={handleFormClose}
            open={creationformOpen}
        // {...other}
        >
            {/* <DialogTitle>
                <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                    <span>LC Document Creation</span>
                    <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                        <Button onClick={handleFormClose}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
                    </div>
                </div>
            </DialogTitle> */}
            <AppBar position="static">
                <Toolbar className="flex w-full justify-between">
                    <Typography variant="subtitle1" color="inherit">
                        LC Document Creation
                    </Typography>
                    <Button onClick={handleFormClose}>
                        <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                    </Button>
                </Toolbar>
            </AppBar>
            <DialogContent dividers>
                {<CreateDocument
                    ref={childRef}
                    successMsg={handlecreateSuccessMsg}
                    selectedRow={selectedRows}
                    checkSaveDisabled={checkSaveDisabled}
                    checkBOEXDisabled={checkBOEXDisabled} />}
            </DialogContent>
            <DialogActions>

                <Tooltip title="BOEX">
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleDownloadBOEX}
                        disabled={BOEXDisabled}
                    >
                        <FuseSvgIcon className="mr-2">material-solid:receipt</FuseSvgIcon>

                    </Button>
                </Tooltip>

                <Tooltip title="Bank Form">
                    <Button
                        variant="contained"
                        color="warning"
                        disabled
                    // onClick={handleSave}
                    //  disabled={saveDisabled}
                    >
                        <FuseSvgIcon >material-solid:list</FuseSvgIcon>
                    </Button>
                </Tooltip>

                <Tooltip title="Save">
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleSaveDocument}
                        disabled={saveDisabled}
                    >
                        <FuseSvgIcon>material-solid:save</FuseSvgIcon>

                    </Button>
                </Tooltip>

            </DialogActions>
        </Dialog >
        <DialogBox
            open={open}
            handleClose={handleFormClose}
            handleSumbit={handleSubmitActive}
            title={!active ? "Active Letter Of Credit" : "Deactive Letter Of Credit"}
        />
        {openLCTopup && <LCTopUp lcId={lCTopupId} handleClose={closeOpenLCTopup} handleAmmendEdit={handleAmmendEdit} handleAmmendView={handleAmmendView} />}
        {openUtilized && <LCUtilized open={openUtilized} lcId={lCTopupId} handleClose={closeOpenLCTopup} successMsg={handleSuccessMsg} />}
        {(openPending || openAccepted || openReceived) && <LCStatusList handleStatusClose={closeOpenLCStatus} lcId={lCTopupId} successMsg={handleSuccessMsg} pendingStatus={openPending ? "Pending" : openReceived ? 'Received' : openAccepted ? 'Accepted' : ''} />}
    </>

}
export default LetterOfCredit